import React, { useEffect, useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import styles from './DatePickerSlider.module.css';
import { format } from 'date-fns';
import Calendar from '../Common/Calendar/Calendar';
import CalendarInactiveIcon from '../../components/icons/Menu/CalendarInactiveIcon';
import ProductModal from '../Common/ProductModal/ProductModal';
import Header from '../Common/Header/Header';
import ContentApp from '../ContentApp';
import { useSelector } from 'react-redux';
import { getLocale } from '../../helpers/dates';

const DatePickerSliderNotEvents = ({
  dates,
  firstDate,
  handleSelect,
  minDate = new Date(),
  datesCalendar,
}) => {
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const [selectedDate, setSelectedDate] = useState(format(new Date(firstDate), 'yyyy-MM-dd'));
  const [calendarVisible, setCalendarVisible] = useState(false);
  const swiperRef = useRef(null);
  const maxDate = new Date(firstDate);
  maxDate.setDate(firstDate.getDate() + 365);

  const onSelect = (date) => {
    setCalendarVisible(false);
    setSelectedDate(date);
    handleSelect(date);
  };

  const slideToIndex = (dateStr) => {
    if (swiperRef.current) {
      const idx = dates.findIndex((p) => format(p.date, 'yyyy-MM-dd') === dateStr);
      if (idx >= 0) swiperRef.current.slideTo(idx);
    }
  };

  useEffect(() => {
    if (firstDate) {
      const initialDate = format(new Date(firstDate), 'yyyy-MM-dd');
      setSelectedDate(initialDate);
      slideToIndex(initialDate);
    }
  }, []);
  useEffect(() => {
    slideToIndex(selectedDate);
  }, [dates, selectedDate]);

  return (
    <>
      {dates.length > 0 && (
        <Swiper
          spaceBetween={5}
          slidesPerView={'auto'}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {dates.map((p, i) => {
            const dateStr = format(p.date, 'yyyy-MM-dd');
            return (
              <SwiperSlide key={i}>
                <button
                  onClick={() => onSelect(dateStr)}
                  className={`${styles.dateButton} ${
                    selectedDate === dateStr ? styles.selected : ''
                  }`}
                  type='button'
                  disabled={!p.hasEvents}
                >
                  <div className='font-extra-small text-capitalize'>
                    {format(p.date, 'eee', { locale })}
                  </div>
                  <div className={styles.number}>{format(p.date, 'dd')}</div>
                  <div className='font-extra-small text-capitalize'>
                    {format(p.date, 'MMM', { locale })}
                  </div>
                </button>
              </SwiperSlide>
            );
          })}
          <SwiperSlide>
            <button
              onClick={() => setCalendarVisible(!calendarVisible)}
              className={styles.dateButton}
              type='button'
            >
              <CalendarInactiveIcon />
            </button>
          </SwiperSlide>
        </Swiper>
      )}
      <ProductModal
        open={calendarVisible}
        fullScreen
        animationClass='fade-up-horizontal'
        hasBackground
        showCloseButton={false}
      >
        <Header onClick={() => setCalendarVisible(false)} showBack />
        <ContentApp>
          <Calendar
            minDate={minDate}
            maxDate={maxDate}
            onSelectDate={(date) => onSelect(format(date, 'yyyy-MM-dd'))}
            selectedDate={selectedDate}
            className='calendar-event'
          />
        </ContentApp>
      </ProductModal>
    </>
  );
};

export default DatePickerSliderNotEvents;
